import FilterPriceRange from './FilterPriceRange';
export default FilterPriceRange;